import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Sustainability.css';

const Sustainability = () => {
  return (
    <>
      <Helmet>
        <title>Sustainability - Environmental Commitment | Redbox Global</title>
        <meta name="description" content="Learn about Redbox Global's sustainability initiatives, environmental commitments, and efforts to achieve carbon neutrality. Discover our green technology, renewable energy programs, and climate action strategies." />
        <meta name="keywords" content="sustainability, environmental responsibility, carbon neutrality, green technology, renewable energy, climate action, ESG, corporate sustainability, net zero emissions, environmental initiatives" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/sustainability" />
        <meta property="og:title" content="Sustainability - Environmental Commitment | Redbox Global" />
        <meta property="og:description" content="Discover how Redbox Global is taking action on climate change through renewable energy, carbon reduction, and sustainable business practices." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/sustainability" />
        <meta name="twitter:title" content="Sustainability - Environmental Commitment | Redbox Global" />
        <meta name="twitter:description" content="Our commitment to environmental sustainability and achieving carbon neutrality by 2030." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/sustainability" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Sustainability at Redbox Global",
            "description": "Redbox Global's environmental sustainability initiatives and commitment to carbon neutrality.",
            "url": "https://redboxglobal.com/sustainability",
            "publisher": {
              "@type": "Organization",
              "name": "Redbox Global",
              "logo": {
                "@type": "ImageObject",
                "url": "https://redboxglobal.com/logo.png"
              }
            },
            "about": {
              "@type": "Thing",
              "name": "Environmental Sustainability"
            }
          })}
        </script>
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>Sustainability</h1>
        <p className="page-subtitle">Our commitment to environmental responsibility and a sustainable future</p>
      </div>
      
      <div className="page-content">
        <a href="/article/net-zero-commitment-2030" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=1200&h=600&fit=crop" alt="Sustainability and renewable energy" />
            </div>
            <div className="featured-content">
              
              <h2>Our Path to Carbon Neutrality by 2030</h2>
              <p>Redbox Global is committed to achieving net-zero carbon emissions by 2030. Learn about our comprehensive sustainability strategy, including transitioning to 100% renewable energy, reducing data center emissions, implementing green technology, and partnering with suppliers committed to environmental responsibility.</p>
              <span className="article-meta">Sustainability Report 2025</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/green-data-centers" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&h=400&fit=crop" alt="Green data centers" />
              </div>
              <div className="article-content">
               
                <h2>Green Data Centers: Powering News with Renewable Energy</h2>
                <p>Our state-of-the-art data centers now run on 85% renewable energy, with advanced cooling systems that reduce water usage by 40% compared to industry standards.</p>
                <span className="article-meta">Technical Details</span>
              </div>
            </article>
          </a>

          <a href="/article/sustainable-supply-chain" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=600&h=400&fit=crop" alt="Sustainable supply chain" />
              </div>
              <div className="article-content">
               
                <h2>Building a Sustainable Supply Chain</h2>
                <p>We're working with suppliers and partners to reduce emissions across our entire value chain, setting ambitious targets for scope 3 emissions reduction.</p>
                <span className="article-meta">Partnership Program</span>
              </div>
            </article>
          </a>

          <a href="/article/employee-sustainability-initiatives" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600&h=400&fit=crop" alt="Employee sustainability programs" />
              </div>
              <div className="article-content">
                
                <h2>Empowering Employees to Drive Sustainability</h2>
                <p>From remote work policies that reduce commuting emissions to green office initiatives, our employees are leading the charge in making Redbox Global more sustainable.</p>
                <span className="article-meta">Get Involved</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default Sustainability;
